export const container = document.querySelector(".container");
export const themeToggler = document.querySelector(".theme__toggle");
export const todoList = document.querySelector(".todo__list");
export const todoListItems = () => document.querySelectorAll(".todo__item");
export const todoForm = document.querySelector(".todo__form");
export const todoInput = document.querySelector(".todo__input");
export const getCheckIcons = () => document.querySelectorAll(".check__icon");
export const getCrossIcons = () => document.querySelectorAll(".cross__icon");
export const filterAll = document.querySelector(".filter__all");
export const filterActive = document.querySelector(".filter__active");
export const filterCompleted = document.querySelector(".filter__completed");
export const clearCompleted = document.querySelector(".clear__button");
export const leftCount = document.querySelector(".left__count");
